import useCollapse from './useCollapse';
var Collapse = function (props) {
    var _a = useCollapse(props), getItems = _a.getItems, collapseClassName = _a.collapseClassName;
    return (<ul className={collapseClassName} role="tablist">
      {getItems()}
    </ul>);
};
export default Collapse;
